import { Box, Stack, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { primary } from '@/theme/colors';
import { QaqcPanelHeader } from './QaqcPanelHeader';
import {
  qaqcPanelNoTemplateBodySx,
  qaqcPanelNoTemplateColumnSx,
  qaqcPanelNoTemplateGraphicWrapperSx,
  qaqcPanelNoTemplateMessageRowSx,
  qaqcPanelNoTemplateRootSx,
} from './styles';

type Props = {
  onClose: () => void;
};

export const QaQcPanelNoTemplateState = ({ onClose }: Props) => {
  return (
    <Box sx={qaqcPanelNoTemplateRootSx}>
      <QaqcPanelHeader onClose={onClose} variant="closeOnly" />
      <Box sx={qaqcPanelNoTemplateBodySx}>
        <Stack direction="column" alignItems="center" sx={qaqcPanelNoTemplateColumnSx}>
          <Box sx={qaqcPanelNoTemplateGraphicWrapperSx}>
            <img src="/assets/row-selection-graphic.svg" alt="" style={{ width: 'auto' }} />
          </Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={qaqcPanelNoTemplateMessageRowSx}
          >
            <InfoIcon htmlColor={primary.light} sx={{ flexShrink: 0 }} />
            <Typography
              fontSize="1.2rem"
              color={primary.light}
              sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
            >
              No job phase template available
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};
